export var EventState;
(function (EventState) {
    EventState[EventState["Replay"] = 0] = "Replay";
    EventState[EventState["Past"] = 1] = "Past";
    EventState[EventState["StartingSoon"] = 2] = "StartingSoon";
    EventState[EventState["Live"] = 3] = "Live";
    EventState[EventState["Future"] = 4] = "Future";
})(EventState || (EventState = {}));
